import { render, staticRenderFns } from "./RoleMenu.vue?vue&type=template&id=de5af83a&"
import script from "./RoleMenu.vue?vue&type=script&lang=js&"
export * from "./RoleMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports